<template>
  <div class="grid grid-cols-1 gap-8 pt-6 md:grid-cols-5">
    <div class="relative px-4 sm:px-0">
      <div>
        <h2 class="text-base font-semibold leading-7 text-gray-900">Cues</h2>
        <p class="mt-1 text-sm leading-6 text-gray-600">
          Enable Cues. Adjust bot behavior depending on Bot placement or user input. You can use Cues for the cases when Bot needs to handle several semi- or un-related topics.
        </p>
      </div>
    </div>
    <div class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-4">
      <div class="px-4 py-2">
        <div class="grid max-w-2xl grid-cols-1 gap-6 sm:grid-cols-6">
          <ToggleGroup v-model="cuesEnabled" class="col-span-full" :name="propsDefs['cuesEnabled'].title" :description="propsDefs['cuesEnabled'].description">
            <div class="col-span-full mt-4 border-l-2 border-indigo-100 pl-4">
              <StdPropArrayEditor
                v-model="cuesWebPlacement"
                class="col-span-full"
                :label="propsDefs['cuesWebPlacement'].title"
                :description="propsDefs['cuesWebPlacement'].description"
                :properties-spec="cuesWebPlacementFormSpecProps"
                @update:valid="handleIsUpdateValid"
              >
              </StdPropArrayEditor>
            </div>

            <div class="col-span-full mt-4 border-l-2 border-indigo-100 pl-4">
              <StdPropArrayEditor
                v-model="cuesContactInformation"
                class="col-span-full"
                :label="propsDefs['cuesContactInformation'].title"
                :description="propsDefs['cuesContactInformation'].description"
                :properties-spec="cuesContactInformationSpecProps"
                @update:valid="handleIsUpdateValid"
              >
              </StdPropArrayEditor>
            </div>
          </ToggleGroup>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
  import InputTextarea from '@/components/Bots/editors/InputTextarea.vue';
  import ToggleGroup from '@/components/Toggles/ToggleGroup.vue';
  import StdBusinessHoursEditor from '@/components/Editors/StdBusinessHoursEditor.vue';
  import { BOT_TYPE_DEFS } from '@/spec/BotTypeDefs';
  import { useBotsStore } from '@/store/BotsStore';
  import { pathOr } from 'ramda';
  import { computed } from 'vue';
  import StdPropArrayEditor from '@/components/Editors/StdPropArrayEditor.vue';
  import StdPropEditor from '@/components/Editors/StdPropEditor.vue';

  const emit = defineEmits(['update:valid']);
  function handleIsUpdateValid(valid) {
    // forward the event
    emit('update:valid', valid);
  }

  const botsStore = useBotsStore();

  const cuesWebPlacementFormSpecProps = [
    { name: 'urlPattern', type: 'stringLong', title: 'URL Pattern', default: '' },
    { type: 'separator', hint: 'Enable KB Filtering: use only subset of KB' },
    { name: 'type', type: 'select', title: 'KB Filtering Type', options: ['KB Document', 'KB Tags', 'None'], values: ['kbDoc', 'kbTags', 'none'], default: 'none' },
    { name: 'value', type: 'string', title: 'Value', default: '' },
    { type: 'separator', hint: 'Set tags on the conversation. Separate tags by comma.' },
    { name: 'tags', type: 'csvAlphaNumeric', title: 'Tags', default: '' },
    //{ name: 'required', type: 'boolean', title: 'Required', default: 'false' },
    //{ name: 'description', type: 'stringLong', title: 'Description', default: '' },
  ];

  const cuesContactInformationSpecProps = [
    { name: 'rule', type: 'stringLong', title: 'Rule', default: '', description: 'define rule based on contact information fields' },
    { type: 'separator', hint: 'Enable KB Filtering: use only subset of KB' },
    { name: 'type', type: 'select', title: 'KB Filtering Type', options: ['KB Document', 'KB Tags', 'None'], values: ['kbDoc', 'kbTags', 'none'], default: 'none' },
    { name: 'value', type: 'string', title: 'Value', default: '' },
    { type: 'separator', hint: 'Set tags on the conversation. Separate tags by comma.' },
    { name: 'tags', type: 'csvAlphaNumeric', title: 'Tags', default: '' },
  ];

  // TODO Refine this - move to BotTypeDefs
  const propsDefs = {};
  (BOT_TYPE_DEFS['questionAnswering']?.props || []).map((p) => {
    propsDefs[p.name] = {
      title: p?.title || '',
      description: p?.description || '',
      default: p?.default || '',
      placeholder: p?.placeholder || '',
    };
  });

  // Can pass array or dot notation path, like "spec.bot.prop"
  // TODO Generalize - move to hooks ? or store ?
  function getPropGetSet(propPath) {
    const pp = Array.isArray(propPath) ? propPath : propPath.split('.');
    return {
      get() {
        return pathOr(null, pp, botsStore.botSpec);
      },
      set(newValue) {
        botsStore.setBotSpecProp(pp, newValue);
      },
    };
  }

  const cuesEnabled = computed(getPropGetSet('cuesEnabled'));
  const cuesWebPlacement = computed(getPropGetSet('cuesWebPlacement'));
  const cuesContactInformation = computed(getPropGetSet('cuesContactInformation'));
</script>
